// eslint-disable-next-line no-unused-vars
import KeywordMovementTable from './KeywordMovementTable'
import helper from '@/services/Helper'

/**
 * Helper for {@link KeywordMovementTable}
 *  table config
 *  @example:
 *  [{type: 'top-level',    //level
        children: 'children',   //children property name
        childrenLimit: '10',   //max length of children inner table if we are using inner pagination for children
        cells: [                // array of table cells with column settings
          {label: 'Rank Zone', // label of first column
            propName: 'label',   // name of property in received form backend data
            style: {              // style stuff
              'flex-basis': '33%'
            }
          },
          {label: 'MSV',
            propName: 'msv',
            filterName: 'commaDividedNumber'  // name filter function that should be applied to value in the table cell
            },...]},
    {type: 'second-level',
        children: 'children',
        childrenLimit: 20,    //max length of children inner table if we are using inner pagination for children
        cells: [
          {propName: 'label',
            style: {
              'flex-basis': '33%'}
          },
          {propName: 'msv',
            filterName: 'commaDividedNumber'
          },...]
          }]
 **/
export const topLevelConfig = {
  type: 'top-level',
  children: 'children',
  childrenLimit: 10,
  cells: [
    {
      label: 'Rank Zone',
      propName: 'label',
      style: {
        'flex-basis': '74%',
        'padding-left': '40px',
        'font-weight': 'bold'
      }
    },
    {
      label: 'MSV',
      propName: 'msv',
      filterName: 'commaDividedNumber',
      style: {
        'flex-basis': '13%',
        'padding-left': '0',
        'font-weight': 'bold'
      }
    },
    {
      label: 'Keyword Count',
      propName: 'keywords',
      filterName: 'commaDividedNumber',
      style: {
        'flex-basis': '13%',
        'padding-left': '0',
        'font-weight': 'bold'
      }
    }
  ]
}

export const secondLevelConfig = {
  type: 'second-level',
  defaultSorting: true,
  sortingCell: 'msv',
  sortingDirection: helper.DIRECTION_DESC,
  cells: [
    {
      propName: 'label',
      style: {
        'flex-basis': '74%',
        'padding-left': '40px',
        'font-weight': 'normal'
      }
    },
    {
      propName: 'msv',
      filterName: 'commaDividedNumber',
      style: {
        'flex-basis': '13%',
        'padding-left': '0',
        'font-weight': 'normal'
      }
    },
    {
      propName: 'keywords',
      filterName: 'commaDividedNumber',
      style: {
        'flex-basis': '13%',
        'padding-left': '0',
        'font-weight': 'normal'
      }
    }
  ]
}

export const isInViewport = (element) => {
  const rect = element.getBoundingClientRect()
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}
